import gql from 'graphql-tag';

export const add = gql`mutation CreateCargoPort($cargoPort: CargoPortInput!) {
    createCargoPort(cargoPort: $cargoPort) {
        id
        cargo {
            id
            quantity
            perTonUsd
            value
            outturnTonnes
            customerReference
            receiver
            blDate
            blNumber
            certificateReference
            supplier
            stowage
            excessExclusion
            commodity{
                id
                name
            }

            cargoPorts {
                id
                cargo {
                    id
                }
                port {
                    id
                }
                operation
                estimatedTimeOfArrival
                isConfirmed
            }

            clientRate {
                id
                name
                creationDate
                client {
                    id
                }
                isMarineOnly
                rate
                franchise
            }
            underwriterRate {
                id
                name
                rate
                company {
                    id
                    name
                }
            }
        }
    }
}`;


export const edit = gql`mutation EditCargoPort($id: ID!, $cargoPort: CargoPortInput!) {
    editCargoPort(id: $id, cargoPort: $cargoPort) {
        id
        cargo {
            id
            quantity
            perTonUsd
            value
            outturnTonnes
            customerReference
            receiver
            blDate
            blNumber
            certificateReference
            supplier
            stowage
            excessExclusion
            commodity{
                id
                name
            }

            cargoPorts {
                id
                cargo {
                    id
                }
                port {
                    id
                }
                operation
                estimatedTimeOfArrival
                isConfirmed
            }

            clientRate {
                id
                name
                creationDate
                client {
                    id
                }
                isMarineOnly
                rate
                franchise
            }
            underwriterRate {
                id
                name
                rate
                company {
                    id
                    name
                }
            }
        }
    }
}`;


// WEBPACK FOOTER //
// ./src/graphql/mutations/cargoPort.js